// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"_9bc06b0c3bf9569281db91b9e7e36de0-less"};